import "./DurationInput.scss";

export default {
  name: "DurationInput",
  props: ["label", "value", "showMinutes", "icon", "hideIcon", "errorText"],
  data: () => ({
    mainPeacock: "#00636C",
    hours: 0,
    minutes: 0
  }),
  methods: {
    setValue() {
      this.$emit("input", parseInt(this.hours) * 60 + parseInt(this.minutes));
    },
    formatValues() {
      this.hours = this.hours.toString().padStart(2, "0");
      this.minutes = this.minutes.toString().padStart(2, "0");
    },
    resetValue() {
      this.$emit("input", 0);
      this.hours = this.minutes = "00";
    },
    timeInit() {
      this.hours = Math.floor(this.value / 60)
        .toString()
        .padStart(2, "0");
      this.minutes = (this.value % 60).toString().padStart(2, "0");
    }
  },
  watch: {
    value() {
      this.timeInit();
    }
  },
  computed: {},

  mounted() {
    setTimeout(() => {
      this.timeInit();
    }, 100);
  },
  updated() {
    this.timeInit();
  }
};
